import { render, staticRenderFns } from "./GlobalSearchUserTable.vue?vue&type=template&id=b28ec016"
import script from "./GlobalSearchUserTable.vue?vue&type=script&lang=js"
export * from "./GlobalSearchUserTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports